var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 24,
    viewBox: "0 0 75 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.362 0C43.0985 0 38.3727 2.73882 38.3727 7.76471C38.3727 13.5529 46.7207 13.9482 46.7207 16.8282C46.7207 18.0424 45.3058 19.1435 42.9287 19.1435C39.5329 19.1435 36.9861 17.6188 36.9861 17.6188L35.9107 22.7012C35.9107 22.7012 38.8255 24 42.7306 24C48.5035 24 53.0313 21.1482 53.0313 16.0094C53.0313 9.91059 44.6549 9.5153 44.6549 6.83294C44.6549 5.87294 45.8152 4.82824 48.1922 4.82824C50.8806 4.82824 53.0879 5.92941 53.0879 5.92941L54.1632 1.01647C54.1349 1.01647 51.7295 0 48.362 0ZM0.141492 0.367059L0 1.10118C0 1.10118 2.20728 1.49647 4.21647 2.31529C6.79163 3.24706 6.96142 3.78353 7.41419 5.44941L12.14 23.6047H18.4789L28.1852 0.367059H21.8747L15.6207 16.1788L13.0739 2.76706C12.8475 1.24235 11.659 0.367059 10.1874 0.367059H0.141492ZM30.7321 0.367059L25.7799 23.6047H31.8074L36.7314 0.367059H30.7321ZM64.2941 0.367059C62.8508 0.367059 62.0868 1.12941 61.5208 2.48471L52.6917 23.6047H59.0022L60.2191 20.0753H67.9163L68.652 23.6047H74.2268L69.3878 0.367059H64.2941ZM65.1147 6.66353L66.9824 15.3882H61.9736L65.1147 6.66353Z",
    fill: "#1434CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.99a10131854b0ec26c8e85de129fcc8c.svg";
export { ForwardRef as ReactComponent };